export default class StatisticsContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "Statistics";
  }

  show(path) {
    const app = this.app;
    const pageId = this.pageId;

    const params = path.split("/");
    let userId = params[1];

    if (!userId) {
      let model = this.getModel(app.userdata)
      app.populate(pageId, model);
      app.swapPage(pageId);
    }
    if (userId) {
      app.accountJD.GetUserDataPublic(userId).then(userdata => {
        let model = this.getModel(userdata)
        app.populate(pageId, model);
        app.swapPage(pageId);
      });
    }

  }
  getModel(userdata) {
    const app = this.app;
    let friends = {};
    if (!userdata) {
      userdata = app.userdata || {};
    }

    friends = userdata.friends || {};

    //get all options
    let categories = app.statistics.categoriesWithLevels;
    let levelsPossible = app.statistics.levels;

    //filter out levels not played
    let levels = [];
    for (let i = 0; i < levelsPossible.length; i++) {
      let level = levelsPossible[i];
      if (userdata["gamesPlayed_" + level]) levels.push(level);

    }
    //create table view model of the stats
    let statsRows = [];
    let statsHeaders = [" "].concat(levels);
    statsRows.push(statsHeaders);
    for (const [key, value] of Object.entries(categories)) {
      let statRow = [];
      statRow.push(value); //label
      for (let level of levels) {
        let statValue = userdata[key + "_" + level];
        statRow.push((statValue || 0));
      }
      statsRows.push(statRow);
    }

    let model = {
      userdata: userdata,
      friends: friends,
      statsRows: statsRows
    };

    return model;
  }

}